
import React from "react";
import{ Navigate} from"react-router-dom";

interface IPrivateRouteProps {
    altPath?:string;
    authorized:boolean;
}
export default function PrivateRoute(props:React.PropsWithChildren<IPrivateRouteProps>) {
    return props.authorized ? props.children : <Navigate to={props.altPath}/>;
} 